import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import ScreenEnter from './ScreenEnter';

/** Stable key per navigable screen so entrance motion can restart. */
export const getScreenEnterKey = (pathname: string): string => {
  const parts = pathname.split('/').filter(Boolean);
  if (!parts.length) return 'home';

  const [root, second, third] = parts;

  if (root === 'hospitality' && second) {
    if (second === 'settings') return 'settings';
    if (second === 'rooms') {
      if (third === 'editroom') return 'rooms/editroom';
      return third ? `rooms/${third}` : 'rooms';
    }
    if (second === 'operations' && third === 'actions') return 'operations/actions';
    return second;
  }

  if (root === 'sales-distribution') {
    return second ? `sales/${second}` : 'sales';
  }
  if (root === 'reporting-analytics') {
    if (second === 'audits' && third) return `audits/${third}`;
    return second || 'reporting';
  }
  if (root === 'settings') {
    // Subpages animate via ScreenEnter inline; keep one shell key.
    return 'settings';
  }
  if (root === 'branches') {
    return second ? `branches/${second}` : 'branches';
  }
  if (root === 'rooms' && second === 'actions') {
    return 'rooms/actions';
  }
  if (root === 'crm') {
    if (parts.length >= 3) return 'crm/chat';
    return second ? `crm/${second}` : 'crm';
  }
  if (root === 'logs' && second) {
    return `logs/${second}`;
  }

  return root;
};

const PageEnter = function PageEnter({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const enterKey = useMemo(() => getScreenEnterKey(pathname), [pathname]);

  return <ScreenEnter enterKey={enterKey}>{children}</ScreenEnter>;
};

export { default as ScreenEnter } from './ScreenEnter';
export default PageEnter;
